import { If } from '~/components';
import { Footer, Wrapper, WrapperContent } from './styles';

interface SceneWrapperProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const SceneWrapper = ({ children, footer }: SceneWrapperProps) => {
  const hasFooter = !!footer;

  return (
    <Wrapper $hasFooter={hasFooter}>
      <WrapperContent>{children}</WrapperContent>
      <If condition={hasFooter}>
        <Footer>{footer}</Footer>
      </If>
    </Wrapper>
  );
};

export default SceneWrapper;
